<template>
    <div class="page" data-page="stories">
        <div class="container">

            <!--Header Banner-->
            <div class="storiesBlock">
                <div
                    class="storiesWrapper"
                    :class="{
                        hide: showVideo
                    }"
                >
                    <span class="badge red">New</span>
                    <h1 class="blockTitle">Stories</h1>
                    <p class="blockDescription">Everyone has their own story. To bring our members even closer without border limits, we are collaborating with YouTubers creating a new segment called "Stories" which will be released monthly. Please subscribe below to get notified.</p>
                </div>

                <div v-if="showVideo" class="backgroundVideo">
                    <video src="https://prismic-io.s3.amazonaws.com/vanmglcom/9ac352eb-6057-431b-8855-ca8775a4c20f_One+Mgl+Intro.mp4" muted autoplay playsinline></video>
                </div>
            </div>

            <!--Stories List-->
            <div class="storiesList pure-g">
                <template v-for="(story, storyIndex) in stories">

                    <div v-if="story.id !== 'subscribed'" :key="`story_${storyIndex}`" class="pure-u-1 pure-md-1-3 pure-u-lg-1-5 storyItem">
                        <div class="storyItemWrapper">
                            <div class="image" :style="`background-image:url(${story.poster});`"></div>
                            <h4 class="title">{{ story.title }}</h4>
                            <p class="desc" v-html="story.desc"></p>
                            <router-link v-if="story.status === 'ready'" :to="`/stories/${story.id}`" class="btn green">Watch</router-link>
                            <p v-else class="status">Coming Soon...</p>
                        </div>
                    </div>

                </template>
            </div>

        </div>
    </div>
</template>

<script>
import Stories from '@/components/Stories'

export default {
    components: {
        Stories
    },

    data(){
        return{
            subscribed: false,
            allSubscribedUsers: null,
            showVideo: false,
            stories: []
        }
    },

    async created(){      
        await this.$bind('stories', this.$firebase.firestore().collection('stories').orderBy('timestamp', 'asc'))

        this.doAnimation()
    },

    methods: {
        getAllSubscribed(){

            let storiesRef = fb.storiesCollection.doc('subscribed')
    
            storiesRef.get().then(snap => {
                if(snap){
                    let allSubscribedUsers = snap.data()

                    this.allSubscribedUsers = allSubscribedUsers

                    if(this.allSubscribedUsers[this.$store.state.currentUser.uid] === true){
                        this.subscribed = true
                    }
                }else{
                    console.log('No subscribed users found!')
                }
            })
            .catch(err => {
                console.log('Error getting all subscribed users.')
            })
        },
        subscribe(){
            if(this.$store.state.currentUser === null){
                
                alert('Please login to subscribe!')

                this.$router.push('/login')

            }else if(!this.subscribed){

                let storiesRef = fb.storiesCollection.doc('subscribed')
                let updates = {}

                updates[this.$store.state.currentUser.uid] = true
                
                storiesRef.update(updates).then(() => {
                    this.$notify({
                        group: 'globalNotifications',
                        title: 'Successfully subscribed to OneMgl Stories.'
                    })
                    this.subscribed = true
                })
                .catch(err => {
                    console.log('Error subscribing user: ', this.$store.state.currentUser.uid)
                })
            }
        },
        doAnimation(){
            setTimeout(() => {
                this.showVideo = true

                setTimeout(() => {
                    this.showVideo = false
                }, 6000)
            }, 2000)
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/Stories/Stories.vue